import React, { useState } from 'react';
import ReactLoading from 'react-loading';
import LocalizedMessage from 'react-l10n';
// import AccountPICNumberForm from './AccountPICNumberForm';
import AccountPICNumberList from './AccountPICNumberList';

function AccountPICNumber(props) {
    const {
        isLoadingList,
        list,
        handleFormSubmission,
        handleDelete,
        handleMakeDefault,
    } = props;
    // const [ showForm, setShowForm ] = useState(false);

    return (
        <React.Fragment>
            <div className='card__header'>
                <span className='card__header-wrapper'>
                    <span className='card__header-icon'>
                        <span className='icon icon-number' />
                    </span>
                </span>
                <h3 className='heading heading--lv4'>
                    <LocalizedMessage id={'ACCOUNT_PIC_NUMBER.HEADING'} />
                </h3>
            </div>
            <div className='vspace vspace--small'>
                <div className='text-box'>
                    <p>
                        <LocalizedMessage id={'ACCOUNT_PIC_NUMBER.CONTENT'} />
                    </p>
                </div>
            </div>
            <div className='row'>
                <div className='col-xs-12 col-md-8'>
                    <div className='vspace vspace--small'>
                        <AccountPICNumberList
                            isLoading={isLoadingList}
                            list={list}
                            onRemoveClick={handleDelete}
                            onMakeDefaultClick={handleMakeDefault}
                        />
                    </div>
                    {/*
                    <div className="tab-content">
                        <div id="default-address-form" className={`tab-pane ${showForm === false && 'active'}`}>
                            <button type="button" className="button button-filter button--grey-border" onClick={() => setShowForm(true)}>
                                <span className="icon icon-plus-thick"></span>
                                <span><LocalizedMessage id={'ACCOUNT_PIC_NUMBER.ADD_NEW'} /></span>
                            </button>
                        </div>
                        <div id="add-new-address-form" className={`tab-pane ${showForm === true && 'active'}`}>
                            <AccountPICNumberForm
                                handleFormSubmission={handleFormSubmission}
                                closeForm={() => setShowForm(false)}
                            />
                        </div>
                    </div>
                    */}
                </div>
            </div>
        </React.Fragment>
    );
}

export default AccountPICNumber;
